import { Tag } from 'antd';
import { FC } from 'react';
import { convertDataSize } from 'src/utils/convertDataSize';
import { twMerge } from '@utils/twMerge';
import { CustomTooltip } from '@dynamika-shared/ui/Tooltip/CustomTooltip';

type SelectedItemsProps = {
  // Recipients mode
  selectedItems?: string[];
  onClose?: (item: string) => void;
  className?: string;
  // Attachments mode
  selectedFiles?: File[];
  onCloseFile?: (file: File) => void;
  getExtraFileTagClassName?: (file: File) => string;
};
export const SelectedQueryItems: FC<SelectedItemsProps> = ({
  selectedItems,
  onClose,
  selectedFiles,
  onCloseFile,
  className,
  getExtraFileTagClassName,
}) => {
  const isFilesMode = !!selectedFiles?.length;
  return (
    <div
      data-testid='SelectedQueryItems'
      className={twMerge('flex flex-col mb-3 mt-2 gap-1 w-[50%]', className)}
    >
      {isFilesMode
        ? selectedFiles.map(file => (
            <Tag
              key={`${file.name}-${file.size}-${file.lastModified}`}
              onClose={() => onCloseFile?.(file)}
              closable
              className={twMerge(
                'max-w-[100%] mr-0 flex items-center justify-between bg-body border border-brightGray py-[6px] ps-2 pe-[6px]  font-normal h-auto !rounded-[8px]',
                getExtraFileTagClassName?.(file) ?? ''
              )}
            >
              <CustomTooltip
                label={`${file.name} (${convertDataSize(file.size)})`}
                MAX_LABEL_LENGTH={50}
                className='text-1420 text-dimGray font-normal truncate'
                overlayInnerStyle={{wordBreak: 'break-word', maxWidth: '90vw'}}
              />
            </Tag>
          ))
        : (selectedItems ?? []).map(item => (
            <Tag
              key={item}
              onClose={() => onClose?.(item)}
              closable
              className='max-w-[100%] mr-0 flex items-center justify-between bg-body border border-brightGray py-[6px] ps-2 pe-[6px]  font-normal h-auto !rounded-[8px]'
            >
              <CustomTooltip
                label={item}
                MAX_LABEL_LENGTH={50}
                className='text-1420 text-dimGray font-normal truncate'
                overlayInnerStyle={{wordBreak: 'break-word', maxWidth: '90vw'}}
              />
            </Tag>
          ))}
    </div>
  );
};
